var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpenseError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6724 8.34743L21.0694 15.5194C21.0254 16.0714 20.5744 16.4854 20.0234 16.4854H20.0194H9.10841H9.10641C8.58541 16.4854 8.14041 16.0974 8.06641 15.5824L7.11641 9.02343C7.09441 8.86743 7.13341 8.71143 7.22841 8.58543C7.32241 8.45843 7.46041 8.37643 7.61641 8.35443C7.82541 8.36243 16.4984 8.35043 21.6724 8.34743ZM20.0254 17.9854C21.3424 17.9854 22.4574 16.9574 22.5644 15.6424L23.4804 4.74843L24.9874 4.48843C25.3964 4.41643 25.6694 4.02943 25.5994 3.62043C25.5274 3.21143 25.1324 2.94543 24.7324 3.00943L22.6524 3.36943C22.3174 3.42843 22.0624 3.70643 22.0334 4.04643L21.7984 6.84743C7.52241 6.85343 7.47641 6.86043 7.40741 6.86843C6.85041 6.94943 6.36041 7.24043 6.02641 7.68843C5.69241 8.13543 5.55241 8.68643 5.63241 9.23843L6.58141 15.7964C6.76041 17.0444 7.84441 17.9854 9.10441 17.9854H9.10941H20.0174H20.0254Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7126 12.0437H13.4846C13.8996 12.0437 14.2346 11.7077 14.2346 11.2937C14.2346 10.8797 13.8996 10.5437 13.4846 10.5437H10.7126C10.2986 10.5437 9.96262 10.8797 9.96262 11.2937C9.96262 11.7077 10.2986 12.0437 10.7126 12.0437Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4555 20.7019C20.1545 20.7019 19.9115 20.9449 19.9115 21.2459C19.9115 21.5469 20.1545 21.7909 20.4555 21.7909C20.7575 21.7909 21.0005 21.5469 21.0005 21.2459C21.0005 20.9449 20.7575 20.7019 20.4555 20.7019Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1053_5502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 20,
    width: 3,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0012 21.2455C21.0012 21.5475 20.7582 21.7915 20.4552 21.7915C20.1542 21.7915 19.9112 21.5475 19.9112 21.2455C19.9112 20.9445 20.1542 20.7015 20.4552 20.7015C20.7582 20.7015 21.0012 20.9445 21.0012 21.2455Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1053_5502)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0002 26.7905H14.9112V15.7015H26.0002V26.7905Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4565 21.0408C20.5695 21.0408 20.6615 21.1328 20.6615 21.2458C20.6615 21.4728 20.2505 21.4728 20.2505 21.2458C20.2505 21.1328 20.3435 21.0408 20.4565 21.0408ZM20.4565 22.5408C21.1705 22.5408 21.7505 21.9598 21.7505 21.2458C21.7505 20.5318 21.1705 19.9518 20.4565 19.9518C19.7425 19.9518 19.1615 20.5318 19.1615 21.2458C19.1615 21.9598 19.7425 22.5408 20.4565 22.5408Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17521 20.702C8.87421 20.702 8.63021 20.945 8.63021 21.246C8.63021 21.547 8.87421 21.791 9.17521 21.791C9.47721 21.791 9.72021 21.547 9.72021 21.246C9.72021 20.945 9.47721 20.702 9.17521 20.702Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1053_5502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 20,
    width: 2,
    height: 2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72021 21.2455C9.72021 21.5475 9.47721 21.7915 9.17521 21.7915C8.87521 21.7915 8.63021 21.5475 8.63021 21.2455C8.63021 20.9445 8.87521 20.7015 9.17521 20.7015C9.47721 20.7015 9.72021 20.9445 9.72021 21.2455Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1053_5502)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7202 26.7905H3.63021V15.7015H14.7202V26.7905Z",
    fill: "black"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17621 21.0408C9.28821 21.0408 9.38021 21.1328 9.38021 21.2458C9.37921 21.4748 8.96921 21.4728 8.97021 21.2458C8.97021 21.1328 9.06321 21.0408 9.17621 21.0408ZM9.17621 22.5408C9.89021 22.5408 10.4702 21.9598 10.4702 21.2458C10.4702 20.5318 9.89021 19.9518 9.17621 19.9518C8.46121 19.9518 7.88021 20.5318 7.88021 21.2458C7.88021 21.9598 8.46121 22.5408 9.17621 22.5408Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C8.757 12 11 9.757 11 7C11 4.243 8.757 2 6 2C3.243 2 1 4.243 1 7C1 9.757 3.243 12 6 12Z",
    fill: "#E0421A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00293 7.68649C6.20993 7.68649 6.37793 7.51849 6.37793 7.31149V5.10199C6.37793 4.89499 6.20993 4.72699 6.00293 4.72699C5.79593 4.72699 5.62793 4.89499 5.62793 5.10199V7.31149C5.62793 7.51849 5.79593 7.68649 6.00293 7.68649Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99799 9.39795C6.27449 9.39795 6.50049 9.17445 6.50049 8.89795C6.50049 8.62145 6.27899 8.39795 6.00299 8.39795H5.99799C5.72149 8.39795 5.49799 8.62145 5.49799 8.89795C5.49799 9.17445 5.72149 9.39795 5.99799 9.39795Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseError);
export default __webpack_public_path__ + "static/media/expense_error.87cd4407ca4c61d66d5c57de9ae5697d.svg";
export { ForwardRef as ReactComponent };